import * as React from "react";
import { forwardRef, memo } from "react";
const SvgArrowDropUp = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("mask", { id: "mask0_583_39850", style: {
  maskType: "alpha"
}, maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 24, height: 24 }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "#D9D9D9" })), /* @__PURE__ */ React.createElement("g", { mask: "url(#mask0_583_39850)" }, /* @__PURE__ */ React.createElement("path", { d: "M7 14L12 9L17 14H7Z", fill: "#637381" })));
const ForwardRef = forwardRef(SvgArrowDropUp);
const Memo = memo(ForwardRef);
export { Memo as ReactComponent };
